import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTheme, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ConfirmButtonProps {
  size: "lg" | "md";
  greenBackground?: boolean;
  color: string;
  backgroundColor: string;
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  isNext?: boolean;
}

export function ConfirmButton(props: ConfirmButtonProps) {
  const { t } = useTranslation();
  const { palette } = useTheme();
  const {
    size,
    greenBackground,
    color,
    backgroundColor,
    onClick,
    disabled,
    text,
    isNext
  } = props;
  return (
    <Button
      onClick={(): void => {
        onClick();
      }}
      id="autostoreConfirmButton"
      sx={{
        border: greenBackground ? `1px solid` : "",
        borderColor: palette.info.main,
        color,
        backgroundColor: disabled ? palette.gray.dark : backgroundColor,
        height: size === "md" ? "100%" : "8vh",
        width: size === "md" ? "80%" : "12vw",
        pt: 0.5,
        fontSize: "20px",
        textTransform: "capitalize",
        "& .MuiButton-startIcon": {
          marginRight: 1
        }
      }}
      disabled={disabled || false}
      startIcon={isNext ? <ArrowRightAltIcon /> : <CheckCircleOutlineIcon />}
    >
      {text || t("confirm")}
    </Button>
  );
}
